<div class="card" *ngIf="isModulesLoaded">
  <div class="card-header card-header-squirrel">
      <!-- <h4>{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}</h4>         -->
      <h4 *ngIf="!isCreateFormCalled">Zusatzmodule bearbeiten</h4>        
      <h4 *ngIf="isCreateFormCalled">Zusatzmodule hinzufügen</h4>        
  </div>
  <div class="card-body" >
    <mat-dialog-content>

      <form [formGroup]="modulesForm"  novalidate>
          
        <table mat-table [dataSource]="modules.controls" class="mat-elevation-z1">

            <!-- Modulname -->
             <div style="max-height: 400px; overflow-y: auto;">
                <ng-container matColumnDef="moduleName">
                    <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Modulname</th>
                    <td mat-cell *matCellDef="let row" style="padding-right: 100px;">
                    {{ row.value.moduleName }}
                    </td>
                </ng-container>

                <!-- Modul-ID -->
                <!-- <ng-container matColumnDef="moduleId">
                    <th mat-header-cell *matHeaderCellDef>Modul-ID</th>
                    <td mat-cell *matCellDef="let row">
                    {{ row.value.moduleId }}
                    </td>
                </ng-container> -->

                <!-- Count (editierbar) -->
                <ng-container matColumnDef="count">
                    <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Gebucht</th>
                    <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row" style="padding-right: 100px;">

                    <mat-form-field appearance="outline" style="width: 100px; margin-top: 1em;">
                        <input
                        matInput
                        type="number"
                        formControlName="count"
                        min="0"
                        />

                        <mat-error *ngIf="row.get('count')?.hasError('min')">
                        Anzahl darf nicht kleiner als
                        {{ row.value.usedCount }} sein
                        </mat-error>

                        <mat-error *ngIf="row.get('count')?.hasError('required')">
                        Pflichtfeld
                        </mat-error>
                    </mat-form-field>

                    </td>
                </ng-container>

                <!-- Used Count -->
                <ng-container matColumnDef="usedCount">
                    <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Verwendet</th>
                    <td mat-cell *matCellDef="let row" style="padding-right: 100px;">
                    {{ row.value.usedCount }}
                    </td>
                </ng-container>

                <!-- Available Count -->
                <ng-container matColumnDef="availableCount">
                    <th mat-header-cell *matHeaderCellDef style="padding-right: 100px;">Verfügbar</th>
                    <td mat-cell *matCellDef="let row" style="padding-right: 100px;">
                    {{ row.value.availableCount }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['moduleName', 'count', 'usedCount', 'availableCount']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['moduleName', 'count', 'usedCount', 'availableCount'];"></tr>
             </div>
            </table>
      </form>
    </mat-dialog-content>


    <div class="row">
        <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                            (click)="cancel()" >Abbruch</button>
        </a>                                                
        <span style="flex: 1 1 auto"></span>
        <a *ngIf="!isCreateFormCalled">
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Ändern der Modulbuchungen"
                                                (click)="add()" [disabled]="modulesForm.invalid">Ändern</button>
        </a>                   
        <a *ngIf="isCreateFormCalled">
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Hinzufügen der Modulbuchungen"
                                                (click)="add()" [disabled]="modulesForm.invalid">Hinzufügen</button>
        </a>                   

    </div>    
  </div>
</div>

